import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import assets from "../utils/assets";
import "./styles.scss";
import CommonButton from "../components/Actionbutton";

const Navbar = ({ className }) => {
  const location = useLocation();
  const handleClick = () => {
    alert("Button Clicked!");
  };

  const [navBg, setNavBg] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setNavBg(true);
      } else {
        setNavBg(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <div className="container-fluid customnav m-0 p-0" >
        <nav className={`navbar navbar-expand-lg row ${className} ${navBg ? "scrolled-nav" : "not-scrolled-nav"}`}>
          <div className={`d-flex align-items-center justify-content-between m-0`}>
            <button
              className="navbar-toggler bg-transparent border-0"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNav"
              aria-controls="navbarNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon "></span>
            </button>

            <Link to="/" className="navbar-brand m-0">
              {className === "navbarColored border-bottom" ? <img src={navBg ? assets.LogoDark : assets.Logo} alt="Logo" /> : <img src={assets.LogoDark} alt="Logo" />}
            </Link>

            <div className="collapse navbar-collapse left-0 top-100" id="navbarNav">
              <ul className="navbar-nav mx-auto">
                <li className="nav-item navbarlink">
                  <Link to="/" className={`nav-link  mx-2 ${location.pathname === "/" ? "active" : ""}`}>
                    Home
                  </Link>
                </li>
                <li className="nav-item navbarlink">
                  <Link to="/industries" className={`nav-link  mx-2 ${location.pathname === "/industries" ? "active" : ""}`}>
                    Industries
                  </Link>
                </li>
                <li className="nav-item navbarlink">
                  <Link to="/pricing" className={`nav-link  mx-2 ${location.pathname === "/pricing" ? "active" : ""}`}>
                    Pricing
                  </Link>
                </li>
                <li className="nav-item navbarlink">
                  <Link to="/blog" className={`nav-link  mx-2 ${location.pathname === "/blog" || location.pathname.startsWith("/blog/") ? "active" : ""}`}>
                    Blog
                  </Link>
                </li>
              </ul>

              <div className="d-flex gap-3 align-items-center">
                <Link to="/Login" className="nav-link  mx-2 login-btn">Login</Link>
                <CommonButton text="See Demo" onClick={handleClick} type="primary" />
              </div>
            </div>

            <div className="d-flex gap-3 align-items-center d-block d-lg-none">
              <Link to="/Login" className="nav-link  mx-2 login-btn">Login</Link>
            </div>
          </div>
        </nav>
      </div>
    </>
  );
};

export default Navbar;
